<template>
  <div>
    <Notification :notify="notify" />

    <div class="row">
      <div class="col">
        Cancellation Confirmation
      </div>
    </div>


  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";

export default {
  name: "CancelPurchaseOrder",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  props: {
    organizationId: { type: Number, required: true}
  },
  watch: {},
  created() {
    this.getPublicationByPagin(this.$route.params.id);
  },
  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getPublicationByPagin(this.$route.params.id);
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getPublicationByPagin(this.$route.params.id);
    },
    getPurchaseOrder(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("purchase-order", id)
          .then((response) => {
            resolve(response);
            console.log(response.data);
            this.item = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSelect(obj) {
      console.log(obj);
      this.$emit("onSelect", obj);
    },
    getPublicationByPagin(id) {
      this.list = [];

      new Promise((resolve, reject) => {
        api
          .getByPagin("purchase-order/cancel/po-publication/" + id + "/" + this.$route.params.organizationId, this.paging)
          .then((response) => {
            this.paging.count = response.data.count;
            this.list = response.data.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  data() {
    return {
      Search: "",
      item: {},
      list: [],
      details: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      paging: { count: 10, page: 1, size: 10, keyword: "", isASC : false },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/PO-Cancellation/CancelPurchaseOrder.vue